import component from './PhSmileyMeh.vue_vue_type_script_lang.vue.js';
export { default } from './PhSmileyMeh.vue_vue_type_script_lang.vue.js';
import { render } from './PhSmileyMeh.vue_vue_type_template_id_5bea2078_lang.vue.js';

component.render = render;
